import { render, staticRenderFns } from "./DisplayTex.vue?vue&type=template&id=29d0241b"
import script from "./DisplayTex.vue?vue&type=script&lang=js"
export * from "./DisplayTex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports